import ReservationMixin from '../../../../components/_mixins/event-reservation'
import DatesMixin from '../../../../components/_mixins/dates'

export default {
  name: 'mini-cart',
  mixins: [ReservationMixin, DatesMixin],
  data() {
    return {
    }
  },
  computed: {
    miniCartItems() {
      return this.proposedCartItems
    },
    subTotal() {
      return _.round(_.sumBy(this.miniCartItems, 'pricing.subtotal'), 2)
    },
    taxTotal() {
      return _.round(_.sumBy(this.miniCartItems, 'pricing.tax'), 2)
    },
    netTotal() {
      return _.round(_.sumBy(this.miniCartItems, 'pricing.total'), 2)
    },
  },
  methods: {
    getDurationTitle(duration) {
      return _.get(this.availableDurations[duration], 'label', duration)
    }
  }
}
